import { render, staticRenderFns } from "./publicVideo.vue?vue&type=template&id=6ab3d5ad&scoped=true"
import script from "./publicVideo.vue?vue&type=script&lang=js"
export * from "./publicVideo.vue?vue&type=script&lang=js"
import style0 from "./publicVideo.vue?vue&type=style&index=0&id=6ab3d5ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab3d5ad",
  null
  
)

export default component.exports